<template>
	<div class="single-seo-txt__container">
		<div class="single-seo-txt__left d-none d-xl-block">
			<img class="" :src="img" :alt="headline" :title="headline">
		</div>
		<div class="single-seo-txt__right">
			<img :src="imgMobile" :alt="headline" :title="headline" class="d-xl-none">
			<div class="single-seo-txt__headline">{{ headline }}</div>
			<div class="single-seo-txt__txt" :class="{'single-seo-txt__txt--open': isOpen}" v-html="text"></div>

			<div class="single-seo-txt__btn" @click="isOpen = !isOpen">
				<svg v-if="!isOpen" width="8" height="8" fill="currentColor">
					<use xlink:href="#plus" />
				</svg>
				<svg v-else width="8" height="8" fill="currentColor">
					<use xlink:href="#minus" />
				</svg>

				{{ $translate("HoferAntikschmuck::Template.lernMore") }}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			headline: String,
			text: String,
			img: String,
			imgMobile: String,
		},

		data(){
			return {
				isOpen: false
			}
		}
	}
</script>
